


import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme/theme.js';
import ScrollFromTop from './ScrollFromTop';
import bookGif from './Images/Book.gif';
import PreLoader from './Components/Preloader.jsx';



// Lazy-loaded components
const Home = lazy(() => import('./pages/Home.jsx'));
const About = lazy(() => import('./pages/About.jsx'));
const Courses = lazy(() => import('./pages/Courses.jsx'));
const Events = lazy(() => import('./pages/Gallery.jsx'));
const ContactUs = lazy(() => import('./pages/RequestCall.jsx'));

const NotFound = lazy(() => import('./NotFound.jsx')); // 404 component


// const PreLoader = () => (
//   <div style={{
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     height: '100vh',
//     textAlign: 'center',
//     fontSize: '1.5em',
//     fontWeight: '800',
//     backgroundColor: '#fff',
//     color: '#356DF1'
//   }}>
//     <img src={bookGif} alt="Loading..." style={{ width: '60px', marginBottom: '10px' }} />
//     <div style={{ fontSize: '1.5em', fontWeight: '800', color: '#356DF1' }}>ITqHub</div>
//   </div>
// );



const App = () => {

  return (
    <Suspense fallback={<PreLoader /> }>
      <ScrollFromTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={ <About />} />
        <Route path="/course-list/:input?" element={  <Courses /> }/>
        <Route path="/gallery"element={  <Events /> }/>
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="*" element={<NotFound />} />
     </Routes>
    </Suspense>
  );
};



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ChakraProvider theme={theme}>
    <Router>
      <App />
    </Router>
  </ChakraProvider>
);
